import React, { useEffect, useState } from "react";
import notificationImage from "../../assets/images/notification.svg";
import logOutImage from "../../assets/images/logout.svg";
import userImage from "../../assets/images/user.svg";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  fetchAllNotifications,
  signoutUser,
  updateActiveAccount,
} from "../../redux/action";
import Avatar from "react-avatar";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Box,
  Image,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";

import $ from "jquery";
const NotificationItem = (data) => {
  return (
    <div className="d-flex flex-row mb-3 pb-3 border-bottom">
      <div className="pl-3 pr-2">
        <span
          style={{ backgroundColor: "#5C5BE3" }}
          className="badge badge-pill badge-primary handle mr-1 ml-5 mb-2"
        >
          {" "}
          {data?.account?.name}
        </span>
        <p className="text-muted mb-0 text-small">
          Messages: {data?.messages?.length}{" "}
        </p>
        <p className="text-muted mb-0 text-small">
          Voicemails: {data?.voicemails?.length}{" "}
        </p>
      </div>
    </div>
  );
};

function Header({ title }) {
  const authUser = useSelector((state) => state.authUser);
  const userselectedFont = useSelector((state) => state.settings.fontsize);
  const notifications = useSelector((state) => state.notifications);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isNotification, setIsNotification] = useState(false);

  const handleLogout = () => {
    dispatch(signoutUser());
    navigate("/login");
  };

  const getNotifications = () => {
    dispatch(fetchAllNotifications());
  };
  const gatherNotification = () => {
    for (let i = 0; i < notifications.data.length; i++) {
      if (notifications?.data[i]?.messages?.length > 0) {
        setIsNotification(true);
        return;
      }
      if (notifications?.data[i]?.voicemails?.length > 0) {
        setIsNotification(true);
        return;
      }
    }
    setIsNotification(false);
  };

  useEffect(() => {
    getNotifications();
  }, []);

  useEffect(() => {
    // getNotifications()
    gatherNotification();
  }, [notifications]);

  const showLeft = () => {
    $(".left-navigation").animate({
      width: "20%",
    });
    $(".main-section").css("width", "80%");
    $("#headerMenuBtn").addClass("d-none");
    $("#leftMenuBtn").removeClass("d-none");
  };
  const handleMobileHeaderClick = () => {
    $(".left-navigation").css("display", "block");
    $(".left-navigation").css("width", "100%");
  };

  return (
    <div
      className="header d-flex justify-content-between px-1 px-md-3 "
      style={{ marginTop: "12px" }}
    >
      <div className="d-flex align-items-center">
        <button
          onClick={showLeft}
          id="headerMenuBtn"
          fontSize={
            userselectedFont === "small"
              ? "18px"
              : userselectedFont === "medium"
              ? "20px"
              : userselectedFont === "large"
              ? "22px"
              : "22px"
          }
          style={{
            fontSize:
              userselectedFont === "small"
                ? "18px"
                : userselectedFont === "medium"
                ? "20px"
                : userselectedFont === "large"
                ? "22px"
                : "22px",
            marginTop: "5px",
          }}
          className="menu-btn me-2 d-none desktop-display"
        >
          <i className="fa-solid fa-bars"></i>
        </button>
        <button
          onClick={handleMobileHeaderClick}
          id="mobileHeaderMenuBtn"
          className="menu-btn me-2 mobile-display"
        >
          <i className="fa-solid fa-bars"></i>
        </button>
        <Box
          fontSize={
            userselectedFont === "small"
              ? "26px"
              : userselectedFont === "medium"
              ? "28px"
              : userselectedFont === "large"
              ? "32px"
              : "32px"
          }
          className="main-head"
        >
          {title}
        </Box>
      </div>

      <div className="controls d-flex align-items-center">
        <div className="position-relative d-inline-block">
          {/*<img src={notificationImage} />*/}
          <UncontrolledDropdown className="dropdown-menu-right">
            <DropdownToggle
              className="header-icon notificationButton"
              color="empty"
              style={{ padding: "0px", borderRadius: "50%" }}
            >
              <Image
                w={
                  userselectedFont === "small"
                    ? "30px"
                    : userselectedFont === "medium"
                    ? "40px"
                    : userselectedFont === "large"
                    ? "50px"
                    : "50px"
                }
                src={notificationImage}
              />
              <div
                className={`${isNotification ? "notification-count-dot" : ""} `}
              ></div>
            </DropdownToggle>
            <DropdownMenu className="position-absolute mt-3 scroll" end>
              <PerfectScrollbar
                options={{ suppressScrollX: true, wheelPropagation: false }}
                style={{ padding: "10px" }}
              >
                {notifications.data.map((notification, index) => {
                  return <NotificationItem key={index} {...notification} />;
                })}
              </PerfectScrollbar>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>

        {/*from here */}

        <div className="ms-2 d-flex align-items-center">
          <UncontrolledDropdown className="dropdown-menu-right">
            <DropdownToggle className="p-0" color="empty">
              {authUser.user && (
                <Box display="flex" alignItems="center">
                  <span>
                    <Avatar
                      size={
                        userselectedFont === "small"
                          ? 28
                          : userselectedFont === "medium"
                          ? 30
                          : userselectedFont === "large"
                          ? 34
                          : 34
                      }
                      name={authUser.user.full_name}
                      round
                    />
                    {/*<img alt="Profile" src={userImage} />*/}
                  </span>
                  <Box
                    fontSize={
                      userselectedFont === "small"
                        ? "14px"
                        : userselectedFont === "medium"
                        ? "16px"
                        : userselectedFont === "large"
                        ? "18px"
                        : "18px"
                    }
                    className="d-none  d-sm-inline user-name ms-2"
                  >
                    {
                      authUser?.user?.accounts.find(
                        (account) => account.id == authUser.activeAccount
                      ).name
                    }
                  </Box>
                </Box>
              )}
            </DropdownToggle>
            <DropdownMenu className="mt-3" style={{ marginLeft: "-80px" }}>
              {authUser?.user?.accounts?.map((item, index) => {
                return (
                  <DropdownItem
                    key={index}
                    onClick={() => dispatch(updateActiveAccount(item.id))}
                    active={item.id == authUser.activeAccount}
                  >
                    {item.name}
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>

        {/* till here*/}

        {/*
        <div className="ms-3 d-flex align-items-center">
          <img src={userImage} />
          <span className="user-name ms-2">{authUser.user.full_name}</span>
            </div>*/}

        <div className="ms-2" onClick={handleLogout}>
          <Image
            w={
              userselectedFont === "small"
                ? "30px"
                : userselectedFont === "medium"
                ? "40px"
                : userselectedFont === "large"
                ? "50px"
                : "50px"
            }
            src={logOutImage}
          />
        </div>
      </div>
    </div>
  );
}

export default Header;
